export enum ESongModalDisplayState {
	ROOT,
	SONG_SETTINGS,
	SONG_INFORMATION,
	SPOTIFY_URL,
	YOUTUBE_URL,
	RECORDED_KEY,
	APPLE_MUSIC_URL,
	SONG_TAGS,
	ROTATION_STATUS,
	DEFAULT_KEY,
	NEW_SONG,
	LYRICS,
	EDIT_LYRICS,
	ENERGY_TAG,
	SONG_TYPE_TAG,
	GOSPEL_TAG,
}
